export enum LocalStorageKeys {
  userId = 'userId',
  token = 'token',
  locale = 'app-locale',
}
